/**
 * The keyboard shortcuts the help panel lists. Each entry is what the app really
 * does (AppShell, AdminShell, HelpContext, VideoPlayer); keep them in step.
 * `keys` are shown as separate key caps; `mac` replaces them on a Mac.
 */
export interface Shortcut {
  keys: string[];
  mac?: string[];
  /** i18n key of what it does. */
  label: string;
}

export interface ShortcutGroup {
  title: string;
  /** Shown only to people who open the Admin Center (HR and admins). */
  staffOnly?: boolean;
  items: Shortcut[];
}

export const SHORTCUT_GROUPS: ShortcutGroup[] = [
  {
    title: 'help.shortcuts.groups.everywhere',
    items: [
      { keys: ['?'], label: 'help.shortcuts.help' },
      { keys: ['Ctrl', 'K'], mac: ['⌘', 'K'], label: 'help.shortcuts.search' },
      { keys: ['Esc'], label: 'help.shortcuts.close' },
    ],
  },
  {
    title: 'help.shortcuts.groups.admin',
    staffOnly: true,
    items: [
      { keys: ['Ctrl', 'K'], mac: ['⌘', 'K'], label: 'help.shortcuts.adminSearch' },
    ],
  },
  {
    title: 'help.shortcuts.groups.video',
    items: [
      { keys: ['Space'], label: 'help.shortcuts.play' },
      { keys: ['←'], label: 'help.shortcuts.back' },
      { keys: ['→'], label: 'help.shortcuts.forward' },
      { keys: ['F'], label: 'help.shortcuts.fullscreen' },
      { keys: ['M'], label: 'help.shortcuts.mute' },
      { keys: ['<', '>'], label: 'help.shortcuts.speed' },
    ],
  },
];

export function isMac(): boolean {
  return typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent || '');
}
